import styled from 'styled-components';
import { StyledComponentsPropWithTheme } from '../../../../commons/components/ChromeApp/ChromeAppUtils';
import { gray100 } from '../../../../colors';
interface SectionNavContainerProps extends StyledComponentsPropWithTheme {
  isMobile?: boolean;
}

export const SectionNavContainer = styled.div<SectionNavContainerProps>`
  padding: 0 ${({ theme }) => theme.spacing.base};
  background: ${(props: StyledComponentsPropWithTheme) =>
    props.theme.header.sectionNav.background};
  border-top: 1px solid ${gray100};
`;
